module.exports = __webpack_public_path__ + "teqbahn-assets/media/resources.98738d88.pdf";